module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_xc40@2x-9cc7e8a5cca04dfb03a5b0f3a911c07b.png";